/* eslint-disable no-param-reassign */
export const mergeDeep = (target: any, source: any) => {
  const isObject = (obj: any) => obj && typeof obj === 'object';

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach((key) => {
    const targetValue = target[key];
    const sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });

  return target;
};

export default {
  mergeDeep,
  join(list: string[], word: 'or'|'and'|undefined) {
    let str = '';
    let i = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const entry of list) {
      if (i !== 0) {
        if (i === list.length - 1) {
          if (word === 'or') {
            str += ' eller ';
          } else {
            str += ' og ';
          }
        } else {
          str += ', ';
        }
      }
      str += entry;
      i += 1;
    }
    return str;
  },
};
